export const NET_RENT_RECEIVED_TOOLTIP_TITLE = "Como é calculado";

export const NET_RENT_RECEIVED_TOOLTIP_BODY =
  "Soma dos repasses líquidos recebidos nos últimos 36 meses, com base nos pagamentos registrados no sistema Kenlo vinculados à sua conta.";

export const NET_RENT_RECEIVED_INFO_LABEL =
  "Como o aluguel líquido recebido é calculado";
